import { LocalStore } from 'constants/localstore';
import { SignInRes } from 'services/auth.service';

export const saveToken = (data: SignInRes) => {
  if (data.token) localStorage.setItem(LocalStore.token, data.token);
  if (data.refreshToken) localStorage.setItem(LocalStore.refreshToken, data.refreshToken);
};
